import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material'
import { useSnackbar } from 'notistack'
import { useDeleteLuckyDraw } from '../../api/lucky-draw'

const Delete = ({ openDelete, data, onClose, refetch }) => {
  const { mutateAsync, isLoading } = useDeleteLuckyDraw()
  const { enqueueSnackbar } = useSnackbar()

  const label = `${data.companyAccountId} - ${data.companyName}`

  const handleDeleteLuckyDraw = async () => {
    try {
      await mutateAsync({ id: data._id })
      refetch()
      enqueueSnackbar(`${label} has been successfully removed.`, { variant: 'success' })
      onClose()
    } catch {
      enqueueSnackbar('An error occurred. Please try again.', { variant: 'error' })
    }
  }

  return (
    <Dialog maxWidth='sm' open={openDelete}>
      <DialogTitle>Confirm Deletion</DialogTitle>
      <DialogContent dividers>
        <Typography>
          Are you sure you want to remove <b>{label}</b> from luckydraw? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          onClick={handleDeleteLuckyDraw}
          disabled={isLoading}
          variant='contained'
          color='primary'
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Delete
